<template>
  <modal :show.sync="dialog">
    <h4 slot="header" class="text-primary m-0">
      <strong>
        <i class="now-ui-icons ui-1_bell-53" style="font-size: 200%; vertical-align: middle; margin-right: 20px"></i>
        {{ $t('app.product_suggestions.title') }}
      </strong>
    </h4>
    <ValidationObserver ref="formAdd" v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(submitAddToCart)">
        <div class="row">
          <div class="col-3">
            <img style="width: 100%;" :src="getFirstImageForProduct(sugerencia.product.producto)" />
          </div>
          <div class="col-9">
            <h3>
              <strong>
                {{ $t('app.product_suggestions.message').replace('{date}', fechaLocalized).replace('{product}', sugerencia.model.material) }}
              </strong>
            </h3>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="form-group">
              <fg-input
                disabled
                type="text"
                :label="$t('app.modules.complaints.headers.product_description')"
                v-model="item.descripcion"
              >
              </fg-input>
            </div>
          </div>
        </div>

        <div class="row" style="margin-top: 15px">
          <div class="col-12">
            <div class="form-group">
              <label>{{ $t("app.modules.product_family_detail.headers.mailing_address") }}</label>

              <el-select
                :placeholder="$t('app.modules.product_family_detail.headers.select_address')"
                size="large"
                v-model="item.direccionId"
                @change="changeOption"
              >
                <el-option
                  v-for="(ad, index) in addresses"
                  :key="'address-'+index"
                  :label=" ad.calle + ' '+ ad.estado + ' '+ ad.pais + ' - ' + ad.razonSocial"
                  :value="ad.idDireccion"
                >
                </el-option>
              </el-select>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-6">
            <div class="form-group">
              <fg-input
                type="number"
                :label="$t('app.modules.product_family_detail.headers.quantity') + ' '+ (item.unidad.length > 0 ? '('+item.unidad+')' : '')"
                v-model="item.quantity"
                min="1"
                :error="item.quantity < 1 ? $t('app.product_suggestions.quantity_required') : false"
              >
              </fg-input>
            </div>
          </div>
          <div class="col-6">
            <div class="form-group">
              <label>{{ $t('app.modules.product_family_detail.headers.delivery_date') }}</label>
              <el-date-picker v-model="item.delivery_date" format="dd-MM-yyyy" type="date"/>
            </div>
          </div>
        </div>



        <div class="row" style="margin-top: 15px">
          <div class="col-12">
            <div class="form-group">
              <label>{{ $t('app.modules.product_family_detail.headers.price') }}</label>
              <h3>{{ priceTitle }}</h3>
            </div>
          </div>
        </div>

        <div
          slot="footer"
          style="margin-top: 10px; padding-top: 20px;border-top: outset;"
          class="text-right"
        >
          <n-button class="pull-left" @click.native="cancelAdd" >{{ $t("app.buttons.cancel") }}</n-button>
          <n-button type="primary" class="pull-left" @click.native="ocultarSugerenciaCompra" >{{ $t('app.product_suggestions.do_not_show_again') }}</n-button>
          <n-button v-if="item.price > 0 && item.quantity > 0"  native-type="button" @click.native="addProducto" type="primary">{{ $t("app.buttons.add") }}</n-button>
        </div>
      </form>
    </ValidationObserver>
  </modal>
</template>

<script>
import {getResponse} from "@/util/utilities";
import {mapMutations} from 'vuex'
import ConstPedidoOrigenCreacion from "@/models/pedidos/ConstPedidoOrigenCreacion";

export default {
  name: "mostrarSugerenciaCompra",
  data () {
    return {
      dialog: false,
      item: {
        descripcion: "",
        quantity: 1,
        delivery_date: "",
        unidad: "",
        moneda: "",
        direccionId: "",
        price: 0,
        productoId: 0,
        origenCreacion: 0,
      },
      productoModel: false,
      addresses: [],
      sugerencia: {
        model: false,
        product: false
      },
      origins: new ConstPedidoOrigenCreacion()
    }
  },
  computed: {
    priceTitle() {
      return this.item.price === 0 ? this.$t('app.modules.product_family_detail.errors.not_available') : this.item.price + " " + this.item.moneda + "/" + this.item.unidad;
    },
      fechaLocalized () {
        if (this.$store.state.lang === 'es') {
          return this.$moment(this.item.delivery_date, 'MM-DD-YYYY').format('D [de] MMMM [de] YYYY')
        } else {
          return this.$moment(this.item.delivery_date, 'MM-DD-YYYY').locale('en').format('MMMM D, YYYY')
        }
      }
  },
  mounted() {
    EventBus.$on('mostrar-sugerencia-compra-inicial', async () => {
      this.$swal.fire({
        title: this.$t("app.promps.wait"),
        html:
          '<div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status"><span class="sr-only">Loading...</span></div>',
        showConfirmButton: false
      });

      //await this.getSugerenciasComprasIA()
      await this.getSugerenciasCompras()

      let item = this.sugerencia.product || false

      if (item) {
        this.item.descripcion = item.producto.textoBreveMaterial;
        this.item.productoId = item.producto.idProducto;
        await this.getAddresses();
      }

      this.$swal.close();

      this.setRecentlyLoggedIn(false)

      let fechaRec = this.$moment(this.item.delivery_date, 'MM-DD-YYYY')
      let control = this.$moment(this.item.delivery_date, 'MM-DD-YYYY').isAfter(this.$moment())
      console.log(this.item.delivery_date)
      console.log(fechaRec)
      console.log(control)

      if (this.productoModel && control) {
        this.dialog = true
      }
    })
  },
  methods: {
    ...mapMutations({
      'setRecentlyLoggedIn': 'SET_IS_RECENTLY_LOGGED_IN'
    }),
    checkMin () {
      if (this.item.quantity < 1) {
        this.item.quantity = 1
      }
    },
    parseJson(icons){
      if (icons) {
        let images = []
        let json = JSON.parse(icons);
        let num = json.length;

        if(num > 0){
          let image = [process.env.VUE_APP_BACK_URL,json[0]].join('/')
          images.push(image)
        }

        return images
      } else {
        return []
      }
    },
    getFirstImageForProduct (producto) {
      let images = producto ? producto.imagenProducto : '[]'
      let imgs = this.parseJson(images)
      if (imgs.length > 0) {
        return imgs[0]
      } else {
        return false
      }
    },
    async getSugerenciasComprasIA () {
      /*
      await this.$http.get(`${process.env.VUE_APP_API_IA_ENDPOINT}/id/${this.$store.state.user.idCliente}`)
        .then(async response => {
          if (response.body) {
            for (let key in response.body) {
              let item = response.body[key]
              this.sugerencia = {
                model: item,
                product: await this.getInformacionProducto(item.idProducto)
              }
            }
          }
        }, error => {
          console.log(error)
          this.notifyMessage('danger', this.$t('app.promps.error'))
        })
        */
    },
    async getInformacionProducto (idProducto) {
      let result = false

      let params = {
        idProducto: idProducto
      }

      await this.$http.post(route('Productos/getInformacionProducto'), params)
        .then(response => {
          result = response.body
        }, error => {
          console.log(error)
          this.notifyMessage('danger', this.$t('app.promps.error'))
        })

      return result
    },
    async getAddresses() {
      let paramClient = {
        clienteId: this.$store.state.user.idClienteSAP
      };
      let requestDir = await this.$http.post(route("Clientes/getDireccionesByCliente"), paramClient);
      let responseDir = getResponse(requestDir);

      if(responseDir != null){
        this.addresses = responseDir.direcciones;
      }
    },
    changeOption(){
      this.loadPrecio();
    },
    async loadPrecio(){
      this.$swal.fire({
        title: this.$t("app.promps.wait"),
        html:
          '<div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status"><span class="sr-only">Loading...</span></div>',
        showConfirmButton: false
      });

      let param = {
        direccionId: this.item.direccionId,
        productoId: this.item.productoId,
        clienteIdSAP: this.$store.state.user.idClienteSAP
      };

      this.item.price = 0;
      this.item.moneda = "";
      this.item.unidad = "";
      this.item.idProductoCliente = 0;

      if(!param.direccionId || !param.productoId || !param.clienteIdSAP) {
        this.$swal.close();
        return
      }

      let request = await this.$http.put(route("Productos/getPrecioByProducto"), param);
      let response = getResponse(request, null);

      if(response && response.productos.length > 0){
        let producto = response.productos[0];
        this.item.price = producto.precioUnitario;
        this.item.moneda = producto.moneda;
        this.item.unidad = producto.unidadMedida;
        this.item.idProductoCliente = producto.idProductoCliente;
      }

      this.$swal.close();
    },
    addProducto(){
      this.$swal.fire({
        title: this.$t("app.promps.wait"),
        html:
          '<div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status"><span class="sr-only">Loading...</span></div>',
        showConfirmButton: false
      });

      try{
        let payload = {idProductoCliente: this.item.idProductoCliente, cantidad: this.item.quantity, fechaEntrega: this.item.delivery_date, origenCreacion: this.origins.RECOMMENDATION}

        if(!payload.idProductoCliente) throw new Error(this.$t("app.modules.product_family_detail.errors.no_client"));
        if(!payload.cantidad || payload.cantidad < 1) throw new Error(this.$t("app.modules.product_family_detail.errors.no_quantity"));
        if(!payload.fechaEntrega) throw new Error(this.$t("app.modules.product_family_detail.errors.no_delivery_date"));

        if (payload.fechaEntrega) {
          payload.fechaEntrega = this.$moment(payload.fechaEntrega, 'MM-DD-YYYY').format()
        }

        EventBus.$emit("add-to-cart", payload);

        this.cancelAdd();
      }
      catch (e){
        this.notifyMessage("danger", e.message);
      }
      finally {
        this.$swal.close();
      }
    },
    cancelAdd(){
      this.item = {
        descripcion: "",
        quantity: 1,
        delivery_date: "",
        unidad: "",
        moneda: "",
        direccionId: "",
        price: 0,
        productoId: 0
      }
      this.dialog = false;
      this.addresses = [];
    },
    async getSugerenciasCompras () {
      const params = {
        id: 0,
        claveIdioma: this.$store.state.lang,
        usuario: this.$store.state.user.idCliente
      }

      console.log('sugerencias compras')
      await this.$http.post(route('SugerenciaCompra/getSugerenciaCompra'), params)
        .then( async response => {
          console.log(response)
          if (response.body) {
            for (let item of response.body.recomendaciones) {
              if (item.b_Mostrar) {
                this.productoModel = item
                this.item.delivery_date = item.fecha_rec
              }
            }

            if (this.productoModel) {
              this.sugerencia = {
                model: this.productoModel,
                product: await this.getInformacionProducto(this.productoModel.idProducto)
              }
            }
          }
        }, error => {
          console.log(error)
          this.notifyMessage('danger', this.$t('app.promps.error'))
        })
    },
    async ocultarSugerenciaCompra () {
      this.$swal.fire({
        title: this.$t("app.promps.wait"),
        html:
          '<div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status"><span class="sr-only">Loading...</span></div>',
        showConfirmButton: false
      });

      this.productoModel.b_Mostrar = false

      await this.$http.put(route('SugerenciaCompra/visualizarSugerencia'), this.productoModel)
      .then(response => {
        console.log(response)
      }, error => {
        console.log(error)
        this.notifyMessage('danger',  this.$t('app.promps.error'))
      })

      this.dialog = false
      this.$swal.close();
    }
  }
};
</script>

<style scoped>

</style>
